import {
  userHasCap,
  userIsAdmin,
  userIsManager,
} from './Auth';
import { getFilesView } from './Files';
import { getSetting } from './Settings';

export const thumbnailPlaceholder = '/images/thumbnails/share.png';

export const shareUserSettingsMap = {
  login_required: 'linkRequireLogin',
  allow_download: 'allowDownload',
  download_reasons: 'downloadReasons',
  status_change: 'statusChange',
  allow_comments: 'allowComments',
  show_people: 'showPeople',
  allow_favoriting: 'allowFavoriting',
  allow_versions: 'allowVersions',
  hide_file_details: 'hideFileDetails',
  watermark: 'watermark',
  include_future_files: 'includeFutureFiles',
  require_email: 'requireEmail',
  require_name: 'requireName',
  select_file_sizes: 'selectFileSizes',
  file_sizes: 'fileSizes',
  view: 'view',
  color: 'color',
  logo: 'logo',
  logo_url: 'logoUrl',
};

export const getShareOptionValue = (key, selectedTemplate = null) => {
  if (selectedTemplate && key in selectedTemplate) return selectedTemplate[key];
  if (key === 'view') return getFilesView();
  if (key === 'file_sizes') return [];
  if (key === 'allow_download') return true;
  if (key === 'color') return null;
  if (key === 'logo') return null;
  if (key === 'logo_url') return null;
  return false;
};

export const canUserManageShare = () => (
  userIsAdmin() || userIsManager() || userHasCap('share_manage_settings')
);

export const canUserCreateShareTemplates = () => (
  userIsAdmin() || userIsManager() || getSetting('share_templates_user_create')
);

export const canUserViewShareDetails = () => (
  userIsAdmin() || userIsManager() || userHasCap('share')
);
